import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import moment from 'moment'
import { Button, Card } from 'antd'
import styles from './styles.less'
import Request from '../../request'
import _ from 'lodash'
import { connect } from 'react-redux'
import S from 'string'
import userRights from '../../components/_utils/userRights'

class CollapseViewBox extends Component {

    state = {
        cp: true
    }

    render() {
        const { cp } = this.state

        return <React.Fragment>
            <div className={cp ? styles.questioncollapse : styles.questioncollapsenot}>{this.props.children}</div>
            <a style={{ color: 'red', float: 'right' }} onClick={() => {
                this.setState({
                    cp: !cp
                })
            }}>
                {cp ? <p>View More + </p> : <p>View Less - </p>}
            </a>
        </React.Fragment>
    }
}


class UniversityReport extends Component {
    state = {
        total: 0,
        loading: false
    }
    apiRequest = params => {

        return new Promise(async resolve => {

            this.setState({ exportParams: params })

            let { univData } = await Request.getUniversitiesReportData({
                ...params,
                regExFilters: ['universityInstitutionName', 'universityCountryName', 'universityStateName', 'universityCityName', 'universityWebsite',
                    'universityType', 'universityCategory', 'universityPartnership', 'universityStatus', 'elicos', 'contactAddress', 'contactAppilcationFee',
                    'contactNameOne', 'contactPhoneOne', 'contactEmailOne', 'contactNameTwo', 'contactPhoneTwo', 'contactEmailTwo', 'contactNameThree',
                    'contactPhoneThree', 'contactEmailThree', 'contactAccountName', 'contactAccountEmail', 'contactAccountPhone', 'enrollmentDocuments',
                    'enrollmentRemarks', 'enrollmentProcedure', 'enrollmentAdmissionOffer', 'enrollmentConfirmation', 'paymentTerms'
                ]
            })

            this.setState({ total: univData.total })

            resolve(univData)
        })
    }
    exportExcel = async () => {
        const { exportParams } = this.state


        this.setState({ loading: true })

        let x = await Request.exportUniversityDataToExcel({
            ...exportParams,
            regExFilters: ['universityInstitutionName', 'universityCountryName', 'universityStateName', 'universityCityName', 'universityWebsite',
                'universityType', 'universityCategory', 'universityPartnership', 'universityStatus', 'elicos', 'contactAddress', 'contactAppilcationFee',
                'contactNameOne', 'contactPhoneOne', 'contactEmailOne', 'contactNameTwo', 'contactPhoneTwo', 'contactEmailTwo', 'contactNameThree',
                'contactPhoneThree', 'contactEmailThree', 'contactAccountName', 'contactAccountEmail', 'contactAccountPhone', 'enrollmentDocuments',
                'enrollmentRemarks', 'enrollmentProcedure', 'enrollmentAdmissionOffer', 'enrollmentConfirmation', 'paymentTerms'
            ]
        })
        this.setState({ loading: false })

        if (!x.error) {
            window.open(x.url)
        }


    }
    reload = () => {
        this.table.current.reload()
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    componentDidMount() {
    }

    render() {
        const { dispatch } = this.props


        const columns = [
            {
                title: 'Country',
                key: 'universityCountryName',
                dataIndex: 'universityCountryName',
                fixed: 'left',
                searchTextName: 'universityCountryName',
                filterRegex: true
            },
            {
                title: 'State',
                key: 'universityStateName',
                dataIndex: 'universityStateName',
                searchTextName: 'universityStateName',
                width: 100,
                filterRegex: true
            },
            {
                title: 'City',
                key: 'universityCityName',
                dataIndex: 'universityCityName',
                searchTextName: 'universityCityName',
                filterRegex: true
            },
            {
                title: 'Campuses',
                key: 'campusVal',
                width: 100,
                searchTextName: 'campus',
                render: (item, record) => {
                    if (record.campus && record.campus.length > 1) {
                        return <CollapseViewBox>
                            {record.campus && _.map(record.campus, (item, index) => {
                                return (

                                    <div key={index} className={styles.alternateColors}>
                                        <div>
                                            <small>{item.campusName}</small>
                                        </div>
                                    </div>

                                )
                            })}
                        </CollapseViewBox>

                    } else {
                        return (

                            <div>
                                {record.campus && record.campus.length > 0
                                    ? record.campus.map((item, c) => {
                                        return (
                                            <div key={c} className={styles.alternateColors}>
                                                <div>
                                                    <small>{item.campusName}</small>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : null}
                            </div>
                        )
                    }
                }
            },
            {
                title: 'Channel Partner',
                key: 'channelPartnerNames',
                dataIndex: 'channelPartnerNames',
                searchTextName: 'channelPartnerCount',
                filterRegex: true
            },
            {
                title: 'Institute Name',
                key: 'universityInstitutionName',
                dataIndex: 'universityInstitutionName',
                searchTextName: 'universityInstitutionName',
                filterRegex: true
            },
            {
                title: 'Application Fee',
                width: 150,
                key: 'contactAppilcationFee',
                dataIndex: 'contactAppilcationFee',
                searchTextName: 'contactAppilcationFee',
                filterRegex: true
            },
            {
                title: 'Website',
                key: 'universityWebsite',
                dataIndex: 'universityWebsite',
                searchTextName: 'universityWebsite',
                filterRegex: true
            },
            {
                title: 'Type',
                key: 'universityType',
                dataIndex: 'universityType',
                searchTextName: 'universityType',
                filterRegex: true
            },
            {
                title: 'Category',
                key: 'universityCategory',
                dataIndex: 'universityCategory',
                searchTextName: 'universityCategory',
                filterRegex: true
            },
            {
                title: 'Partnership',
                width: 120,
                key: 'universityPartnership',
                dataIndex: 'universityPartnership',
                searchTextName: 'universityPartnership',
                filterRegex: true
            },
            {
                title: 'Status',
                key: 'universityStatus',
                dataIndex: 'universityStatus',
                searchTextName: 'universityStatus',
                filterRegex: true
            },
            {
                title: 'Institutional Targets/Year',
                key: 'institutionalTargets',
                dataIndex: 'institutionalTargets'
            },
            {
                title: 'ELICOS',
                key: 'elicos',
                dataIndex: 'elicos',
                searchTextName: 'elicos',
                filterRegex: true
            },
            {
                title: 'Address',
                key: 'contactAddress',
                dataIndex: 'contactAddress',
                searchTextName: 'contactAddress',
                filterRegex: true
            },
            {
                title: 'Admission person 1 Name',
                key: 'contactNameOne',
                dataIndex: 'contactNameOne',
                searchTextName: 'contactNameOne',
                filterRegex: true
            },
            {
                title: 'Phone',
                key: 'contactPhoneOne',
                dataIndex: 'contactPhoneOne',
                searchTextName: 'contactPhoneOne',
                filterRegex: true
            },
            {
                title: 'Email',
                key: 'contactEmailOne',
                dataIndex: 'contactEmailOne',
                searchTextName: 'contactEmailOne',
                filterRegex: true
            },
            {
                title: 'Admisison person 2 name',
                key: 'contactNameTwo',
                dataIndex: 'contactNameTwo',
                searchTextName: 'contactNameTwo',
                filterRegex: true
            },
            {
                title: 'Phone',
                key: 'contactPhoneTwo',
                dataIndex: 'contactPhoneTwo',
                searchTextName: 'contactPhoneTwo',
                filterRegex: true
            },
            {
                title: 'Email',
                key: 'contactEmailTwo',
                dataIndex: 'contactEmailTwo',
                searchTextName: 'contactEmailTwo',
                filterRegex: true
            },
            {
                title: 'Marketing Person',
                key: 'contactNameThree',
                dataIndex: 'contactNameThree',
                searchTextName: 'contactNameThree',
                filterRegex: true
            },
            {
                title: 'Phone',
                key: 'contactPhoneThree',
                dataIndex: 'contactPhoneThree',
                searchTextName: 'universityInstitutionName',
                filterRegex: true
            },
            {
                title: 'Email',
                key: 'contactEmailThree',
                dataIndex: 'contactEmailThree',
                searchTextName: 'contactEmailThree',
                filterRegex: true
            },
            {
                title: 'Accounts Person',
                key: 'contactAccountName',
                dataIndex: 'contactAccountName',
                searchTextName: 'contactAccountName',
                filterRegex: true
            },
            {
                title: 'Phone',
                key: 'contactAccountPhone',
                dataIndex: 'contactAccountPhone',
                searchTextName: 'contactAccountPhone',
                filterRegex: true
            },
            {
                title: 'Email',
                key: 'contactAccountEmail',
                dataIndex: 'contactAccountEmail',
                searchTextName: 'contactAccountEmail',
                filterRegex: true
            },
            {
                title: 'Basic Admission Documents',
                key: 'enrollmentDocuments',
                dataIndex: 'enrollmentDocuments',
                searchTextName: 'enrollmentDocuments',
                filterRegex: true,
                render: (text, record) => {

                    if (record && record.enrollmentDocuments) {
                        let u = record.enrollmentDocuments
                        if (u && u.length <= 100) {
                            return <div>{u ? S(u).s : 'N/A'}</div>
                        } else {
                            return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                        }
                    }

                }
            },
            {
                title: 'Remarks',
                key: 'enrollmentRemarks',
                dataIndex: 'enrollmentRemarks',
                searchTextName: 'enrollmentRemarks',
                filterRegex: true,
                render: (text, record) => {

                    if (record && record.enrollmentRemarks) {
                        let u = record.enrollmentRemarks
                        if (u && u.length <= 100) {
                            return <div>{u ? S(u).s : 'N/A'}</div>
                        } else {
                            return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                        }
                    }

                }
            },
            {
                title: 'Procedure Steps',
                key: 'enrollmentProcedure',
                dataIndex: 'enrollmentProcedure',
                searchTextName: 'enrollmentProcedure',
                filterRegex: true,
                render: (text, record) => {

                    if (record && record.enrollmentProcedure) {
                        let u = record.enrollmentProcedure
                        if (u && u.length <= 100) {
                            return <div>{u ? S(u).s : 'N/A'}</div>
                        } else {
                            return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                        }
                    }

                }
            },
            {
                title: 'Offer Processing Time',
                key: 'enrollmentAdmissionOffer',
                dataIndex: 'enrollmentAdmissionOffer',
                searchTextName: 'enrollmentAdmissionOffer',
                filterRegex: true
            },
            {
                title: 'COE/CAS Processing Time',
                key: 'enrollmentConfirmation',
                dataIndex: 'enrollmentConfirmation',
                searchTextName: 'enrollmentConfirmation',
                filterRegex: true
            },
            {
                title: 'Agreement signing date',
                key: 'agreementSigningDate',
                searchDateName: 'agreementSigningDate',

                render: (val, record) => {
                    return (
                        <div>{record && record.agreementSigningDate ? moment(record.agreementSigningDate).format('DD-MMM-YYYY') : ''}</div>)
                }
            },
            {
                title: 'Agreement Expiry Date',
                key: 'enrollmentExpiry',
                searchDateName: 'enrollmentExpiry',

                render: (val, record) => {
                    return (
                        <div>{record && record.enrollmentExpiry ? moment(record.enrollmentExpiry).format('DD-MMM-YYYY') : ''}</div>)
                }
            },
            {
                title: 'Agreement Renewal Date',
                key: 'enrollmentRenewal',
                searchDateName: 'enrollmentRenewal',
                render: (val, record) => {
                    return (
                        <div>{record && record.enrollmentRenewal ? moment(record.enrollmentRenewal).format('DD-MMM-YYYY') : ''}</div>)
                }
            },
            {
                title: 'Payment Terms',
                key: 'paymentTerms',
                dataIndex: 'paymentTerms',
                searchTextName: 'paymentTerms',
                filterRegex: true,
                render: (text, record) => {

                    if (record && record.paymentTerms) {
                        let u = record.paymentTerms
                        if (u && u.length <= 100) {
                            return <div>{u ? S(u).s : 'N/A'}</div>
                        } else {
                            return <CollapseViewBox>{u ? S(u).s : 'N/A'}</CollapseViewBox>
                        }
                    }

                }
            },
            {
                title: 'Language/Foundation/Flat Amount/Undergraduate/Postgraduate',
                key: 'language',
                dataIndex: 'language',
                render: (val, record) => {
                    return (
                        <div>
                            <div>{record.language != 0 ? record.language : "NIL"}/</div>
                            <div>{record.foundation != 0 ? record.foundation : "NIL"}/</div>
                            <div>{record.flatAmount != 0 ? record.flatAmount : "NIL"}/</div>
                            <div>{record.undergraduate != 0 ? record.undergraduate : "NIL"}/</div>
                            <div>{record.postgraduate != 0 ? record.postgraduate : "NIL"}/</div>
                        </div>
                    )
                }
            }
        ]


        return (
            <PageHeaderWrapper title={`
          Total Universities : ${this.state.total}`}>
                <Card style={{ marginBottom: 10 }}>
                    {
                        userRights.checkRights("UniversityReportExcelExport.view") ?
                            <Button type={'default'}
                                loading={this.state.loading}
                                onClick={() => {
                                    this.exportExcel()
                                }}>Export Excel</Button>
                            : null
                    }
                </Card>

                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        extraProps={{ scroll: { x: 3500 } }}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UniversityReport)
